module.exports = __webpack_public_path__ + "img/img1.3eac83df.png";